/**
 * Shared error classifier for `module_setting` HTTP failures consumed by
 * `useModuleSetting`, `useSaveModuleSetting`, and `useResetModuleSetting`
 * (TASK-180).
 *
 * Distinct from `useFormConfig.classifyError` (TASK-178) because the
 * editor cares about `conflict` (409 optimistic-lock) and
 * `validation-failed` (400) as first-class outcomes whereas the renderer
 * folds those into `server-error`.
 */
export var MODULE_SETTING_ERROR_REASONS = [
    'not-found',
    'forbidden',
    'validation-failed',
    'conflict',
    'server-error',
    'network',
];
/**
 * Classify a thrown error from `ky.{get,put,delete,post}(...)`. ky throws
 * `HTTPError` with `error.response.status` for non-2xx; everything else
 * is a network / parse failure.
 *
 * Exported for unit testing.
 */
export var classifyModuleSettingError = function (err) {
    var _a;
    if (err && typeof err === 'object' && 'response' in err) {
        var status_1 = (_a = err.response) === null || _a === void 0 ? void 0 : _a.status;
        if (status_1 === 404)
            return 'not-found';
        if (status_1 === 403)
            return 'forbidden';
        if (status_1 === 400)
            return 'validation-failed';
        if (status_1 === 409)
            return 'conflict';
        if (typeof status_1 === 'number' && status_1 >= 500)
            return 'server-error';
        if (typeof status_1 === 'number' && status_1 >= 400)
            return 'server-error';
    }
    return 'network';
};
